module.exports = __webpack_public_path__ + "img/组 7783@2x.7d11c65d.png";